import React, { useEffect, useState, useMemo } from 'react';
import { useItems } from '../contexts/ItemsContext';
import { useUser } from '../contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import './Programs.css';
import ProductCard from '../components/ProductCard';
import PageHeader from '../components/PageHeader';

const GENRES = ['מיניטס'];
const FILTER_TAGS = [
  "חנוכה", "ט\"ו בשבט", "פורים", "משפחתי", "יומולדת", "בת מצווה",  "תחרותי"
];

const Minites = () => {
  const { itemsByGenre, loadItems, refreshItems, loadingByGenre, errorByGenre } = useItems();
  const { user, addFavorite, removeFavorite } = useUser();
  const navigate = useNavigate();
  const genres = GENRES;

  const [options, setOptions] = useState({ crowds: [], timings: [], types: [] });
  const [filtersLoading, setFiltersLoading] = useState(false);
  const [filtersError, setFiltersError] = useState(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [priceRange, setPriceRange] = useState([10, 200]);

  const highlightStyle = useMemo(() => {
    const containerWidth = 260;
    const marginLeft = 9;
    const marginRight = 9;
    const availableWidth = containerWidth - marginLeft - marginRight;
    const rangeMin = 10;
    const rangeMax = 200;
    const rangeSize = rangeMax - rangeMin;
    const minRatio = (priceRange[0] - rangeMin) / rangeSize;
    const maxRatio = (priceRange[1] - rangeMin) / rangeSize;
    const minPositionReversed = marginLeft + ((1 - minRatio) * availableWidth);
    const maxPositionReversed = marginLeft + ((1 - maxRatio) * availableWidth);
    const leftPx = maxPositionReversed;
    const widthPx = minPositionReversed - maxPositionReversed;
    return {
      left: `${leftPx}px`,
      width: `${widthPx}px`,
    };
  }, [priceRange]);

  useEffect(() => {
    genres.forEach(g => loadItems(g));
  }, []);

  const items = genres.flatMap(g => itemsByGenre[g] || []);
  const loading = genres.some(g => loadingByGenre[g]);
  const error = genres.map(g => errorByGenre[g]).find(Boolean);

  const openItem = (item) => {
    navigate(`/item/${item.id}`);
  };

  const isItemFavorite = (item) => {
    if (!user?.likes) return false;
    return user.likes.some(like => like.id === item.id);
  };

  const toggleFavorite = async (item) => {
    if (!user) return;
    if (isItemFavorite(item)) {
      await removeFavorite(item.id);
    } else {
      await addFavorite(item);
    }
  };

  const allTags = FILTER_TAGS;

  const filteredItems = useMemo(() => {
    return items.filter(it => {
      if (selectedTags.length > 0) {
        const itTypes = (it.types || []).map(t => (typeof t === 'object' ? t.name || t.id : String(t)));
        const itTimings = (it.timings || []).map(t => (typeof t === 'object' ? t.name || t.id : String(t)));
        const all = [...itTypes, ...itTimings];
        const hasAny = selectedTags.some(tag => all.includes(tag));
        if (!hasAny) return false;
      }
      if (selectedVideo === 'with' && !it.video) return false;
      if (selectedVideo === 'without' && it.video) return false;
      if (it.price < priceRange[0] || it.price > priceRange[1]) return false;
      return true;
    });
  }, [items, selectedTags, selectedVideo, priceRange]);

  return (<>
<PageHeader>
בשביל מיניטס, אפילו לא צריך סיבה מיוחדת למסיבה. כל כך כיף לחגוג איתם!{'\n'}
וכמובן, אם בכל מקרה מפגש נערך, והוא צריך תוכן קליל ומשמח - המיניטס זה בדיוק זה.{'\n'}
תוכניות פעילות של שלב אחד. מצחיקות, תחרותיות, סוחפות ומגבשות.{'\n'}
תני לנו להדליק לכם אשששש!!!{'\n'}
כאן-כאן-כאן את בוחרת לך את המיניטס הבא 👇👇👇
</PageHeader>
    <div className="programs-container">
      <div className="programs-frame">
        <div className="programs-filters">
          <div className="filters-row filters-row-top">
            <div className="filters-price">
              <div className="range-wrap">
                <div className="range-track"></div>
                <div className="range-highlight" style={highlightStyle} />
                <input
                  type="range"
                  min={10}
                  max={200}
                  step={1}
                  value={priceRange[0]}
                  onChange={e => {
                    const newVal = parseInt(e.target.value, 10);
                    if (newVal < priceRange[1]) {
                      setPriceRange([newVal, priceRange[1]]);
                    }
                  }}
                  className="range range-min"
                />
                <input
                  type="range"
                  min={10}
                  max={200}
                  step={1}
                  value={priceRange[1]}
                  onChange={e => {
                    const newVal = parseInt(e.target.value, 10);
                    if (newVal > priceRange[0]) {
                      setPriceRange([priceRange[0], newVal]);
                    }
                  }}
                  className="range range-max"
                />
              </div>
              <div className="range-values">
                <span>{priceRange[0]} ₪</span>
                <span>{priceRange[1]} ₪</span>
              </div>
            </div>
            <div className="filters-tags">
              {allTags.map(tag => (
                <button
                  key={tag}
                  className={`tag-btn ${selectedTags.includes(tag) ? 'active' : ''}`}
                  onClick={() =>
                    setSelectedTags(
                      selectedTags.includes(tag)
                        ? selectedTags.filter(t => t !== tag)
                        : [...selectedTags, tag]
                    )
                  }
                >
                  {tag}
                </button>
              ))}
            </div>
          </div>
          <div className="filters-row filters-row-bottom">
            <button
              className="filters-clear"
              onClick={() => {
                setSelectedTags([]);
                setSelectedVideo(null);
                setPriceRange([10, 200]);
              }}
            >
              נקה מסננים
            </button>
            <div className="filters-count">
              מציג {filteredItems.length} מתוך {items.length}
            </div>
          </div>
        </div>
        <div className="filters-actions"></div>
        {loading && <div className="programs-loading">...חכי שניה, זה עולה</div>}
        {error && <div className="programs-error"> :) אופססססס, פשלה! איזה בושות </div>}
        <div className="programs-grid">
          {filteredItems.map(it => (
            <ProductCard
              key={it.id}
              item={it}
              onOpen={openItem}
              onToggleFavorite={toggleFavorite}
              isFavorite={isItemFavorite(it)}
              showMinitsLabel={true}
            />
          ))}
        </div>
        {!loading && !error && items.length === 0 && <div className="programs-empty">חיפשנו, לא מצאנו כלום :(</div>}
      </div>
    </div>
    </>
      );
};

export default Minites;
